import React from "react";

import ActionDropdown from "components/Common/ActionDropdown";
import { Steward, LinkText } from "components/Common/TableStyle";

export const COLUMN_DATA = (handleEdit, handleDelete, userPermissions) => [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
    fixed: "left",
    width: 150,
    className: "cs-ui-table-background",
    render: (text, row) => (
      <LinkText text={text} link={row.id} state={{ parent: text }} />
    ),
  },
  {
    dataIndex: "description",
    key: "description",
    title: "Description",
    width: 200,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "drafter",
    key: "drafter",
    title: "Drafter",
    width: 100,
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    dataIndex: "approver",
    key: "approver",
    title: "Approver",
    width: 100,
    render: row => <Steward name={row?.name} title={row?.role} />,
  },
  {
    dataIndex: "is_secured",
    key: "is_secured",
    title: "Secured CDE",
    width: 100,
    render: row => {
      if (row === "") return "No";
      else if (row === "phi") return "PHI";

      return "Business Sensitive";
    },
  },
  {
    dataIndex: "mapping_status",
    key: "mapping_status",
    title: "Mapping Status",
    width: 100,
    render: text => <div className="whitespace-pre-line">{text}</div>,
  },
  {
    dataIndex: "data_source_count",
    key: "data_source_count",
    title: "# Data Source",
    width: 100,
    render: text => (text ? text : 0),
  },
  {
    title: "Action",
    dataIndex: "id",
    key: "id",
    align: "center",
    width: 100,
    render: (_, record) => (
      <ActionDropdown
        editProps={{
          onClick: () => handleEdit(record),
          "data-cy": "cde-definition-edit-button",
        }}
        deleteProps={{
          onClick: () => handleDelete(record),
          "data-cy": "cde-delete-button",
        }}
        userPermissions={userPermissions}
      />
    ),
  },
];

export const QUICK_FILTER_DATA = (
  setFilter,
  missingDescriptionCount,
  incompleteMappingsCount
) => [
  {
    label: "Missing Descriptions",
    value: missingDescriptionCount,
    onClick: () =>
      setFilter({
        filterBy: "description =",
        filterValue: "",
      }),
  },
  {
    label: "Incomplete Mappings",
    value: incompleteMappingsCount,
    onClick: () =>
      setFilter({
        filterBy: "incomplete_mappings",
        filterValue: "CdeDefinition",
      }),
  },
];

export const SUMMARY_DATA = [
  {
    name: "Medication",
    "Data sources": 135,
    "DSDE mapped": 125,
  },
  {
    name: "Provider",
    "Data sources": 115,
    "DSDE mapped": 60,
  },
  {
    name: "Claims",
    "Data sources": 115,
    "DSDE mapped": 115,
  },
  {
    name: "Hospital",
    "Data sources": 135,
    "DSDE mapped": 105,
  },
];
